export default "<div id=\"callback\">\n  <div>\n    <i class=\"fas fa-spinner\"></i>\n  </div>\n</div>\n"